$(document).on('click', '.remove_fields', function(e){
  e.preventDefault();
  $(this).closest(".js-nested-item").find('input[type=hidden][name$="[_destroy]"]').val(1);
  $(this).closest('.js-nested-item').addClass('is-hidden');
});

$(document).on('click', '.add_nested_fields', function(e){
  e.preventDefault();
  var time=new Date().getTime();
  var regexp=new RegExp($(this).data('id'),'g');
  $($(this).data('wrapper')).append($(this).data('fields').replace(regexp,time));
  console.log($(this).data('wrapper'));
  $($(this).data('wrapper')).find('[data-position-field]').toArray().forEach((element, index) => {
    $(element).val(index);
  })
});
